import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../nucleo/api';
import type { ModuloWeb } from '../../nucleo/modulos';
import { CartaoIndicador } from '../../nucleo/ui/Estados';
import { dicionario } from './i18n';
import { formatarDinheiro } from './tipos';

/** F10: a receber e a pagar na semana e recebimentos atrasados (BRL). */
function Indicadores() {
  const { t, i18n } = useTranslation('contas');
  const q = useQuery({
    queryKey: ['contas', 'resumo'],
    queryFn: () => api<{ receber_semana: string; pagar_semana: string; atrasados_qtd: number; atrasados_centavos: string }>('/api/v1/contas/resumo'),
  });
  const d = q.data;
  const atrasados = !!d && d.atrasados_qtd > 0;
  // ROB-01: o cartão do núcleo distingue carregando ("...") de erro (traço e "Tentar de novo").
  return (
    <>
      <CartaoIndicador rotulo={t('indicadores.receberSemana')} valor={d ? formatarDinheiro(d.receber_semana, 'BRL', i18n.language) : null} consultas={[q]} />
      <CartaoIndicador
        rotulo={t('indicadores.atrasados')}
        valor={d ? <span className={atrasados ? 'text-laranja' : undefined}>{formatarDinheiro(d.atrasados_centavos, 'BRL', i18n.language)}</span> : null}
        consultas={[q]}
        detalhe={atrasados ? <p className="mt-1 text-xs text-tinta-3">{t('indicadores.documentos', { count: d.atrasados_qtd })}</p> : undefined}
      />
      <CartaoIndicador rotulo={t('indicadores.pagarSemana')} valor={d ? formatarDinheiro(d.pagar_semana, 'BRL', i18n.language) : null} consultas={[q]} />
    </>
  );
}

const carregar0 = () => import('./Documentos');
const carregar1 = () => import('./Ficha');
const carregar2 = () => import('./Recorrencias');
const carregar3 = () => import('./Cobrancas');
const carregar4 = () => import('./PainelParceiro');

const AcaoNotas = acaoSobDemanda(carregar0, 'AcaoNotas');
const AcaoPagar = acaoSobDemanda(carregar0, 'AcaoPagar');
const AcaoReceber = acaoSobDemanda(carregar0, 'AcaoReceber');
const ListaDocumentos = telaSobDemanda(carregar0, 'ListaDocumentos');
const FichaDocumento = telaSobDemanda(carregar1, 'FichaDocumento');
const AcaoRecorrencias = acaoSobDemanda(carregar2, 'AcaoRecorrencias');
const Recorrencias = telaSobDemanda(carregar2, 'Recorrencias');
const Cobrancas = telaSobDemanda(carregar3, 'Cobrancas');
const PainelParceiro = telaSobDemanda(carregar4, 'PainelParceiro');

export const modulo: ModuloWeb = {
  slug: 'contas',
  menu: 'financeiro',
  dicionario,
  abas: [
    { rotulo: 'abas.receber', caminho: 'a-receber', elemento: <ListaDocumentos visao="receber" />, Acao: AcaoReceber, ordem: 7 },
    { rotulo: 'abas.pagar', caminho: 'a-pagar', elemento: <ListaDocumentos visao="pagar" />, Acao: AcaoPagar, ordem: 8 },
    { rotulo: 'abas.notas', caminho: 'notas-de-credito', elemento: <ListaDocumentos visao="notas" />, Acao: AcaoNotas, ordem: 9 },
    { rotulo: 'abas.recorrencias', caminho: 'recorrencias', elemento: <Recorrencias />, Acao: AcaoRecorrencias, ordem: 10 },
    { rotulo: 'abas.cobrancas', caminho: 'cobrancas', elemento: <Cobrancas />, ordem: 11 },
  ],
  rotas: [{ path: 'financeiro/documentos/:id', element: <FichaDocumento /> }],
  // M1.7 (SPEC1-03): documentos a receber e a pagar do parceiro na ficha do Cadastros.
  paineis: [{ entidade: 'cadastros.parceiro', titulo: 'painel.titulo', Componente: PainelParceiro, ordem: 20 }],
  Indicadores,
};
